import React, { createContext, useContext } from 'react';

export type RenderTarget = 'pdf' | 'screen';

const RenderTargetContext = createContext<RenderTarget>('screen');

export const RenderTargetProvider: React.FC<{ target: RenderTarget; children: React.ReactNode }> = ({ target, children }) => (
    <RenderTargetContext.Provider value={target}>{children}</RenderTargetContext.Provider>
);

export const useRenderTarget = (): RenderTarget => useContext(RenderTargetContext);
